/**
 * Cordis Workflow API client — calls workflow API endpoints.
 * Authorization via INTERNAL_API_KEY.
 */

const WORKFLOW_BASE =
  process.env.REACT_APP_WORKFLOW_BASE_URL ||
  'https://mri-portal.onrender.com';

function getApiKey() {
  // Prefer env var injected at build time, fall back to localStorage for dev
  return process.env.REACT_APP_INTERNAL_API_KEY || localStorage.getItem('cordis_api_key') || '';
}

function authHeaders() {
  return {
    'Authorization': `Bearer ${getApiKey()}`,
    'Content-Type': 'application/json',
  };
}

export async function sendEvidenceReview(engagementId) {
  const res = await fetch(`${WORKFLOW_BASE}/email/evidence-lock/${engagementId}`, {
    method: 'POST',
    headers: authHeaders(),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function sendPresentationInvite(engagementId) {
  const res = await fetch(`${WORKFLOW_BASE}/email/presentation-invite/${engagementId}`, {
    method: 'POST',
    headers: authHeaders(),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function sendReportReady(engagementId) {
  const res = await fetch(`${WORKFLOW_BASE}/email/report-ready/${engagementId}`, {
    method: 'POST',
    headers: authHeaders(),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}
